module.exports = __webpack_public_path__ + "assets/checkout-b41aae.svg";